import * as yup from 'yup';

export const validationSchema = yup.object({
  email: yup
    .string()
    .email('Enter a valid email')
    .required('Please enter your email'),
  isConsentChecked: yup.boolean().oneOf([true], 'Please agree with terms'),
});
